export default {
  init() {
    // JavaScript to be fired on all pages

    //Valikon avaava animaatio
    // $('.hamburger').click(function () {
    //   $('.hamburger').toggleClass('hamburger--active');
    //   $('.site-header__menu-container').toggleClass('site-header__menu-container--open');
    //   $('html').toggleClass('navigation-open');
    // });


    // $(window).on('resize', function () {
    //   if ($(window).width() > 1024) {
    //     $('.site-header__menu-container').removeClass('site-header__menu-container--open');
    //     $('.hamburger').removeClass('hamburger--active');
    //     $('html').removeClass('navigation-open');
    //   }
    // });

    //Valikon avaava animaatio
    $('.hamburger').click(function () {
      $('.hamburger').toggleClass('hamburger--active');
      $('.mobile-navigation-container').toggleClass('mobile-navigation-container__open');
      $('html, .main-content').toggleClass('mobile-navigation-open');
    });

    /*global Foundation:true*/
    /* exported Foundation */
    var $accordion = new Foundation.AccordionMenu($('.product-categories'), {
      slideSpeed: 300,
      multiOpen: true,
      parentLink: true,
      submenuToggle: true,
    });

    $($accordion).foundation();

    // Anchor link scroller 
    // Animates scroll to target anchror

    $(function () {
      $('a[href*="#"]:not([href="#"])').click(function () {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top,
            }, 1000);
            return false;
          }
        }
      });
    });

    // document.addEventListener('wpcf7mailsent', function (event) {
    //   window.dataLayer.push({
    //     'event': 'cf7submission',
    //     'formId': event.detail.contactFormId,
    //   });
    // });

  //send to form
    $( '.ask-more' ).on( 'click', function() {
      $('.subject').val($( this ).data('subject'));
      console.log($( this ).data('subject') );
    });

//   const askMore = document.querySelector('.ask-more');

//   askMore.addEventListener('click', function() {
//   const subject = document.querySelector('.subject');
//   // console.log(subject)
//   subject.textContent = askMore.dataset.subject;
// })

// Parallax scrolli

window.addEventListener('scroll', onScroll, false);

var latestKnownScrollY = 0,
  ticking = false;

function onScroll() {
  latestKnownScrollY = window.scrollY;
  requestTick();
}

function requestTick() {
  if (!ticking) {
    requestAnimationFrame(update);
  }
  ticking = true;
}

function update() {
  // reset the tick so we can
  // capture the next onScroll
  ticking = false;

  var currentScrollY = latestKnownScrollY;

  //var $this = $(this);
  var itemPosition;
  var speed;
  var bottom_of_element;
  var bottom_of_screen;
  var top_of_screen;

  var items = $('.parallax');

  items.each(function () {

    itemPosition = $(this).offset();
    bottom_of_screen = $(window).scrollTop() + $(window).height();
    top_of_screen = $(window).scrollTop();
    bottom_of_element = itemPosition.top + $(this).outerHeight();

    if ((bottom_of_screen > itemPosition.top) && (top_of_screen < bottom_of_element)) {

      speed = $(this).attr('data-parallax-speed');
      $(this).css('transform', 'translateY(' + (currentScrollY.toFixed(0) * speed) + 'px)');

    }
  });
  // and compare to the currentScrollY value
  // then apply some CSS classes
  // to the visible items
}

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js